import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=c7508a26&scoped=true"
import script from "./Pagina.vue?vue&type=script&lang=ts"
export * from "./Pagina.vue?vue&type=script&lang=ts"
import style0 from "./Pagina.vue?vue&type=style&index=0&id=c7508a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7508a26",
  null
  
)

export default component.exports